module.exports = __webpack_public_path__ + "img/TW.aaede19f.svg";